import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { NbButtonModule, NbContextMenuModule, NbIconModule, NbUserModule } from '@nebular/theme';

@NgModule({
    declarations: [HeaderComponent],
    exports: [HeaderComponent],
    imports: [CommonModule, NbButtonModule, NbUserModule, NbContextMenuModule, NbIconModule],
})
export class HeaderModule {}
